import type React from "react";
import { LuSearch } from "react-icons/lu";

export interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = "Search...",
  className,
}) => {
  return (
    <div className={`relative ${className}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="
  w-full pl-10 pr-4 py-2 bg-surface
  border border-gray-800
  rounded-md
  text-secondary-200
  placeholder:text-gray-500
  focus:outline-none
  focus:border-primary-500
  focus:ring-2 focus:ring-primary-500
"
      />
      <LuSearch
        className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-500"
        aria-hidden="true"
      />
    </div>
  );
};
